%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: f1565e2ac6d6cbe4bb0b302c1b554d10, type: 3}
  m_Name: Spellscatter
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 199898, guid: 7bbe36e923d120540a9d42d5002a84f5, type: 3}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 7489370104637420957, guid: 2a0cebb6dfd66ca428f8e23c279102a8,
    type: 3}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 0}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 10
  castDelay: 0
  animationSpeed: 2
  animationDuration: 0.4
  skipCooldownOnChannel: 0
  spellName: Spellscatter
  description: "If the target is casting, <b>Interrupt</b> them and prevent them
    from casting the same spell for <b>8</b> seconds and any other spell for <b>4</b>
    seconds. \n\nIf the target is not casting, prevent them from casting any spell
    for <b>2</b> seconds."
  icon: {fileID: 2800000, guid: 98e62f857d70c3843b19466f48c4ee54, type: 3}
  usableBy: 000000000400000009000000
  cooldown: 25
  castTime: 0
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 0
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  spellType: {fileID: 11400000, guid: cac5c20beb8c65d47b88d3b03bc2946d, type: 2}
